import { render } from "./redPacket.vue?vue&type=template&id=46c2dc5c"
import script from "./redPacket.vue?vue&type=script&lang=js"
export * from "./redPacket.vue?vue&type=script&lang=js"

import "./redPacket.vue?vue&type=style&index=0&id=46c2dc5c&lang=css"

import exportComponent from "D:\\workspace_front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__